import { Navigate } from "react-router-dom"
import { useActivation } from "@/lib/activation-context"
import { useSession } from "@/lib/session-context"

export const TOTAL_STEPS = 5

export function effectiveActivationStep(currentStep, step2) {
  if (currentStep > 2 && !step2?.strategyLocked) return 2
  return currentStep
}

export function useDashboardGuard() {
  const { currentUser } = useSession()
  const { currentStep, step2, isHydrating } = useActivation()
  if (!currentUser) return <Navigate to="/" replace />
  if (isHydrating) return null
  const activationStep = effectiveActivationStep(currentStep, step2)
  if (activationStep <= TOTAL_STEPS) return <Navigate to={`/activation/step/${activationStep}`} replace />
  return null
}
